// extracted by mini-css-extract-plugin
export default {"yearsTab":"yearTabCommon_yearsTab__+dxR5","yearsTabItem":"yearTabCommon_yearsTabItem__CD5NS"};